<section class="flex flex-col gap-10 max-w-lg mx-auto">
  <!-- Title -->
  <div class="flex flex-col gap-4">
    <h1 class="text-xl font-medium sm:text-2xl md:text-3xl">
      Access your account
    </h1>
    <p class="text-normal font-light">
      It appears that {{ court().name }} is the correct jurisdiction for you to
      continue this application process.
    </p>
  </div>

  <!-- Register button -->
  <div class="flex flex-col gap-2">
    <ui-button (click)="openRegister()" variant="secondary" class="w-full">
      Register
    </ui-button>
    <div class="text-sm font-light">
      <span
        appIcon
        name="info"
        [size]="18"
        class="inline-block align-middle pb-1 text-secondary-50"></span>
      Create a new account to proceed.
    </div>
  </div>

  <!-- Login button -->
  <div class="flex flex-col gap-2">
    <ui-button variant="primary" class="w-full" (click)="showLogin()">
      Login
    </ui-button>
    <div class="text-sm font-light">
      <span
        appIcon
        name="info"
        [size]="18"
        class="inline-block align-middle pb-1 text-primary-50"></span>
      If you have an account, log in.
    </div>
  </div>
</section>
